const STORAGE_PREFIX = 'eonea';

const getFromStorage = (key) => {
  try {
    const data = sessionStorage.getItem(`${STORAGE_PREFIX}[${key}]`);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

const saveToStorage = (key, value) => {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}[${key}]`, JSON.stringify(value));
  } catch {
    // Quota exceeded or storage unavailable — silently skip caching
  }
};

const parseData = (data, parser) => {
  if (!parser) return data;
  return parser.generate(data);
};

const getData = async (url, options = {}) => {
  const { key = url, parser, signal } = options;

  const storeData = getFromStorage(key);
  if (storeData) return parseData(storeData, parser);

  const response = await fetch(url, signal ? { signal } : {});

  if (!response.ok) {
    throw new Error(`HTTP ${response.status} fetching ${url}`);
  }

  const data = await response.json();

  saveToStorage(key, data);

  return parseData(data, parser);
};

export default getData;